// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectorPill_wrapper__tzIiF","wrapperProp103":"SelectorPill_wrapperProp103__JOr6h","button":"SelectorPill_button__jaEug","checkImg":"SelectorPill_checkImg__l-SeY"};